<template>
  <div class="container">
    <!-- <b-message  type="is-danger"  v-if="notFound">Kein Content vorhanden!</b-message> -->
    <transition name="fade">
      <section v-if="display" class="content u-p1" v-html="display"></section>
    </transition>
    <section v-if="!display">
      <content-placeholders>
        <content-placeholders-heading :img="false" />
        <content-placeholders-text :lines="5" />
      </content-placeholders>
    </section>

    <div v-if="$whitelabel.analyticsType">
      <div v-if="isPrivacyPage" id="gaOptout" class="js-gaOutput u-p1">
        <hr />
        <b-notification v-if="isAnalyticsDeactivated" type="is-info" :aria-close-label="$t('general.close')" class="js-alert--ga">
          <p class="mb-4">{{ $t('analytics-options.disabled') }}</p>
          <b-button type="is-info" outlined inverted v-on:click="gaOptin">{{ $t('analytics-options.enable') }}</b-button>
        </b-notification>
        <b-button v-if="!isAnalyticsDeactivated" type="is-dark" v-on:click="gaOptout">{{ $t('analytics-options.disable') }}</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import axios from 'axios'
import * as marked from 'marked'
//import {bootstrap} from 'vue-gtag'
import DOMPurify from 'dompurify'
import * as matter from 'gray-matter'
export default {
  name: 'mdpage',
  components: {},
  breadcrumb() {
    return {
      label: this.currentTitle,
      parent: 'search',
    }
  },
  data() {
    return {
      display: null,
      notFound: false,
      currentTitle: '',
      currentDescription: '',
      //gaDeactivated: false,
      isPrivacyPage: false,
      title: 'Dynamic Terms Label',
      parent: 'home',
    }
  },
  methods: {
    gaOptout() {
      this.$store.dispatch('deactivateAnalytics')
    },
    gaOptin() {
      this.$store.dispatch('activateAnalytics')
    },
    async loadData(route) {
      if (route.params.key) {
        let page = this.pages.find(f => f.slug === route.params.key.toLowerCase() && f.locale == this.locale)
        if (page) {
          const {data} = await axios({
            method: 'get',
            url: page.location,
            responseType: 'text',
          })
          if (data) {
            let frontMatter = matter(data)
            if (!frontMatter.isEmpty) {
              this.currentTitle = frontMatter.data.title
              this.currentDescription = frontMatter.data.description
              if (frontMatter.data.privacypolicy) {
                this.isPrivacyPage = frontMatter.data.privacypolicy
              }
            }
            const clean = DOMPurify.sanitize(frontMatter.content)
            this.display = marked(clean)
          } else {
            this.notFound = true
          }
        } else {
          this.$router.push({name: '404'})
        }
      } else {
        this.$router.push({name: '404'})
      }
    },
  },
  computed: {
    ...mapGetters({
      isAnalyticsDeactivated: 'isAnalyticsDeactivated',
      pages: 'pages',
      locale: 'locale',
      pendingContent: 'pendingContent',
    }),
  },
  async mounted() {
    const route = this.$route
    if (this.pendingContent) {
      let unsubscribe = this.$store.subscribe(async mutation => {
        if (mutation.type === 'CONTENT_RECEIVED') {
          unsubscribe()
          await this.loadData(route)
        }
      })
    } else {
      await this.loadData(route)
    }
  },
  watch: {
    //already mounted - gibts sicher bessere möglichkeit ...
    async $route(to) {
      const route = to
      await this.loadData(route)
    },
    async locale() {
      const route = this.$route
      await this.loadData(route)
    },
  },
  metaInfo() {
    //const metaTitle = this.$options.filters.capitalize(this.currentTitle);
    const metaTitle = this.currentTitle
    const metaDescription = this.currentDescription

    return {
      title: metaTitle,
      meta: [{name: 'description', content: metaDescription}],
    }
  },
}
</script>
